// extracted by mini-css-extract-plugin
export default {"photoContainer":"styles_photoContainer__B6c3O","photo":"styles_photo__Wb03I"};